import { createSlice } from '@reduxjs/toolkit'

export const projectSlice = createSlice({
    name: 'projectslice',
    initialState: {
      value: []
    },
    reducers: {
      projectChange: (state, action) => {
        state.value = action.payload.value
      }
    }
  })
  // 每个 case reducer 函数会生成对应的 Action creators
  export const { projectChange } = projectSlice.actions
  
  export default projectSlice.reducer